/* =============================================
   FUNNY COLLECTIBLES — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile nav toggle ----
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav  = document.getElementById('mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
    });
  }

  // ---- Cart drawer ----
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartToggle  = document.getElementById('cart-toggle');
  var cartClose   = document.querySelector('.cart-drawer__close');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.openCartDrawer = openCartDrawer;

  if (cartToggle)  cartToggle.addEventListener('click', openCartDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // ---- Update cart count globally ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('#cart-count');
        badges.forEach(function (b) { b.textContent = cart.item_count; });
      });
  }
  window.updateCartCount = updateCartCount;

  // ---- Cart drawer: qty + remove ----
  document.addEventListener('click', function (e) {

    // Quick-add from product cards
    var atcBtn = e.target.closest('.product-card__atc');
    if (atcBtn && !atcBtn.disabled) {
      e.preventDefault();
      var variantId = atcBtn.dataset.variantId;
      if (!variantId) return;
      atcBtn.textContent = '...';
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.textContent = '✓ Added!';
        updateCartCount();
        refreshCartDrawer();
        setTimeout(function () {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          openCartDrawer();
        }, 900);
      })
      .catch(function () {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      });
    }

    // Drawer qty: decrease
    var decreaseBtn = e.target.closest('.cart-drawer__body .qty-btn[data-action="decrease"]');
    if (decreaseBtn) {
      var key = decreaseBtn.dataset.key;
      var valEl = decreaseBtn.nextElementSibling;
      var current = parseInt(valEl.textContent) || 1;
      updateCartItem(key, Math.max(0, current - 1));
    }

    // Drawer qty: increase
    var increaseBtn = e.target.closest('.cart-drawer__body .qty-btn[data-action="increase"]');
    if (increaseBtn) {
      var key = increaseBtn.dataset.key;
      var valEl = increaseBtn.previousElementSibling;
      var current = parseInt(valEl.textContent) || 1;
      updateCartItem(key, current + 1);
    }

    // Drawer remove
    var removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      updateCartItem(removeBtn.dataset.key, 0);
    }
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount();
      refreshCartDrawer();
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subtotal = document.getElementById('cart-subtotal');
        if (subtotal) {
          subtotal.textContent = formatMoney(cart.total_price);
        }
        // Reload drawer body for simplicity
        var body = document.getElementById('cart-drawer-body');
        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty 🛒</p><a href="/collections/all" class="btn btn--primary">Start Shopping</a></div>';
        } else {
          var html = cart.items.map(function (item) {
            return '<div class="cart-item" data-key="' + item.key + '">' +
              '<a href="' + item.url + '" class="cart-item__image-link"><img src="' + item.image + '" alt="" width="72" height="72" loading="lazy"></a>' +
              '<div class="cart-item__details">' +
                '<a href="' + item.url + '" class="cart-item__name">' + item.product_title + '</a>' +
                '<p class="cart-item__price">' + formatMoney(item.final_price) + '</p>' +
                '<div class="cart-item__quantity">' +
                  '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '">−</button>' +
                  '<span class="qty-value">' + item.quantity + '</span>' +
                  '<button class="qty-btn" data-action="increase" data-key="' + item.key + '">+</button>' +
                '</div>' +
              '</div>' +
              '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 1L1 13M1 1l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
            '</div>';
          }).join('');
          html += '<div class="cart-drawer__footer">' +
            '<div class="cart-drawer__subtotal"><span>Subtotal</span><span id="cart-subtotal">' + formatMoney(cart.total_price) + '</span></div>' +
            '<p class="cart-drawer__note">Shipping & taxes calculated at checkout</p>' +
            '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>' +
            '<a href="/cart" class="btn btn--outline btn--full">View Cart</a>' +
          '</div>';
          body.innerHTML = html;
        }
      });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  // ---- Announcement bar dismiss ----
  var annBar = document.querySelector('.announcement-bar');
  if (annBar) {
    annBar.style.cursor = 'default';
  }

  // ---- Generic slider init (shared by product sliders + reviews slider) ----
  function initSlider(sliderSection, trackSelector) {
    trackSelector = trackSelector || '[data-slider-track]';
    var track   = sliderSection.querySelector(trackSelector);
    var prevBtn = sliderSection.querySelector('[data-slider-prev]');
    var nextBtn = sliderSection.querySelector('[data-slider-next]');
    if (!track) return;

    function getScrollAmount() {
      var slide = track.firstElementChild;
      if (!slide) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap) || 20;
      return slide.offsetWidth + gap;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });

    var isDown = false, startX = 0, scrollLeft = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('mouseleave', function () { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mouseup',    function () { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mousemove',  function (e) {
      if (!isDown) return; e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
  }

  // ---- Product Sliders ----
  document.querySelectorAll('.hero-slider').forEach(function (s) { initSlider(s); });

  // ---- Reviews Slider ----
  document.querySelectorAll('.reviews-slider').forEach(function (s) {
    initSlider(s, '.reviews-slider__track');
  });

  // ---- Scroll-reveal for product cards ----
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .value-prop').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

});
